// Address of a private file in the signed-in person's storage, served by /api/media.
export const mediaUrl = (key: string): string => `/api/media/${key.split('/').map(encodeURIComponent).join('/')}`
